function getEnvVar(key: string): string {
  if (typeof process !== "undefined" && !!process.env && !!process.env[key]) {
    return process.env[key]!;
  }
  //@ts-ignore
  return import.meta.env[key]!;
}

export const config = {
  dealflowUrl: getEnvVar("VITE_DEALFLOW_SERVICE_URL"),
  noteServiceUrl: getEnvVar("VITE_NOTE_SERVICE_URL"),
  noteServiceColor: getEnvVar("VITE_NOTE_SERVICE_COLOR"),
  instrumentServiceUrl: getEnvVar("VITE_INSTRUMENT_SERVICE_URL"),
  instrumentServiceColor: getEnvVar("VITE_INSTRUMENT_SERVICE_COLOR"),
  customFieldServiceUrl: getEnvVar("VITE_CUSTOMFIELD_SERVICE_URL"),
  customFieldServiceColor: getEnvVar("VITE_CUSTOMFIELD_SERVICE_COLOR"),
  dealServiceUrl: getEnvVar("VITE_DEAL_SERVICE_URL"),
  dealServiceColor: getEnvVar("VITE_DEAL_SERVICE_COLOR"),
  userServiceUrl: getEnvVar("VITE_USER_SERVICE_URL"),
  userServiceColor: getEnvVar("VITE_USER_SERVICE_COLOR"),
  openIdBaseUrl: getEnvVar("VITE_OPEN_ID_BASE_URL"),
  chatbotUrl: getEnvVar("VITE_CHATBOT_URL"),
  mcpClientUrl: getEnvVar("VITE_MCP_CLIENT_URL"),
  mixpanelId: getEnvVar("VITE_MIXPANEL_ID"),
  mixpanelApiHost: getEnvVar("VITE_MIXPANEL_API_HOST"),
  clientId: getEnvVar("VITE_SSO_CLIENT_ID"),
  fundwaveServerExp: /^https:\/\/[a-zA-Z0-9-]+\.(get)?fundwave\.(com|dev)\/.*/i,
  servicesExp: /^https:\/\/(?![^\.]*(oidc|openid))[a-zA-Z0-9-\.]+\.(jcurve|dealflow|fundwave|cloudfunctions|run)\.(app|net|cloud|dev)\/?(?![^\.]*(oidc|openid|refresh))[a-zA-Z0-9-\.]+/i
};

export const fundwavePatterns = [config.fundwaveServerExp, config.servicesExp];

export type RecalculateScope = "sheet" | "workbook";

export enum Screen {
  Login = "login",
  Home = "home",
  Report = "report",
  EditorWarning = "editor-warning"
}